import { mapActions } from 'vuex';

export default {
	directives: {
		log: {
			inserted: function(el, binding, vnode) {
				try {
					const component = vnode.context;

					if (binding.value) {
						if (binding.value.event) {
							if (vnode.componentInstance) {
								//a custom Vue.js component
								//it will emit it's data wit the event so pass it to the listener function
								//that will set it as eventData
								//but if the v-log declaration has eventData, it should override it
								vnode.componentInstance.$on(
									binding.value.event,
									function(e) {
										let logData = getLogData(e);

										component.logEvent(logData);
									}
								);
							} else {
								//native DOM element
								//binding.value will have the eventData
								//that could be a value or function to call to get the value
								el.addEventListener(
									binding.value.event,
									function() {
										let logData = getLogData();

										component.logEvent(logData);
									}
								);
							}
						}
					}

					const getLogData = function getLogData(emittedEventData) {
						let data = emittedEventData;
						let logData;

						if (binding.value.eventData) {
							if (typeof binding.value.eventData === 'function') {
								data = binding.value.eventData();
							} else {
								data = binding.value.eventData;
							}
						}

						logData = { ...binding.value, eventData: data };

						return logData;
					};
				} catch (error) {
					if (process.env.NODE_ENV !== 'production') {
						//don't throw logging errors on prod
						throw error;
					}
				}
			}
		}
	},
	methods: {
		...mapActions('logging', ['logEventAction']),
		logEvent(e) {
			try {
				this.logEventAction({
					route: this.$route,
					data: e
				});
			} catch (error) {
				if (process.env.NODE_ENV !== 'production') {
					//don't throw logging errors on prod
					throw error;
				}
			}
		}
	}
};
